// React imports
import { useState } from 'react';

// General imports
import axios from 'axios';

// MUI imports
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

function PickOffersAndMarkWonDialog(props) {
    const { opportunity, onClose, onNewOpportunity, organizationId, accesstoken, onError, defaultOffer } = props;
    const [ popupWorking, setPopupWorking ] = useState(false);

    async function onSetStatus({ status, selectedOffer }) {
        try {
            const { data: posted } = await axios.put(`/api/opportunities/${opportunity.id}?organizationId=${organizationId}&accesstoken=${accesstoken}`, {
                opportunity: { status, ...(selectedOffer ? { selected: [ selectedOffer ]} : {}) }
            });

            onNewOpportunity({ opportunity: { ...opportunity, ...posted } });
        } catch (e) {
            onError(e);
        }
    }

    async function onAcceptOffer(offerId) {
        setPopupWorking(true);
        await onSetStatus({ status: 'completed', selectedOffer: offerId });
        setPopupWorking(false);
        onClose();
    }

    return (
        <PickOffers opportunity={opportunity} onClose={() => {
            setPopupWorking(false);
            onClose();
        }} working={popupWorking} onAccept={onAcceptOffer} defaultOffer={defaultOffer} />
    )
}

export default PickOffersAndMarkWonDialog;

function PickOffers(props) {
    const { opportunity, onClose, onAccept, working, defaultOffer } = props;
    const [ selectedOffer, setSelectedOffer ] = useState(defaultOffer ? defaultOffer : null);

    function onChange(event) {
        setSelectedOffer(event.target.value);
    }

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle>Choose which offer to accept:</DialogTitle>
            <DialogContent>
                <RadioGroup value={selectedOffer} onChange={onChange}>
                    {opportunity.offers.map(offer => (
                        <FormControlLabel
                            control={<Radio />}
                            label={offer.title}
                            value={offer.id}
                        />
                    ))}
                </RadioGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={working}>Cancel</Button>
                <Button sx={{ width: '100px' }} onClick={() => onAccept(selectedOffer)} disabled={!selectedOffer || working}>
                    {working && <CircularProgress size={14} />}
                    {working ? '' : 'Accept'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}